export const marketingSpecialist = {
  id: 'marketing-specialist',
  version: 2,
  renderer: 'enterprise',
  name: 'Marketing Specialist',
  layout: 'two-column',
  theme: 'modern-teal',
  persona: ['creative'],
  atsLevel: 'B',
  scoreWeights: {
    ats: 30,
    visual: 40,
    executive: 15,
    student: 15
  },
  sectionOrder: ['personal-info', 'summary', 'experience', 'projects', 'education', 'skills', 'languages'],
  components: {
    header: 'header-classic',
    experience: 'experience-classic',
    projects: 'projects-list',
    skills: 'skills-categorized',
    education: 'education-section'
  },
  metadata: {
    industry: ['Digital Marketing', 'Brand Management', 'E-Commerce'],
    companies: ['Unilever', 'P&G', 'Adobe', 'HubSpot', 'Nike', 'L\'Oreal'],
    ats: ['Lever', 'Greenhouse', 'Workday'],
    pages: { min: 1, max: 2, preferred: 1 },
    photo: true,
    icons: true,
    density: 'comfortable',
    columns: 2,
    experienceLevel: ['Entry-level', 'Mid-level', 'Senior'],
    recommendedFor: ['Digital Marketers', 'Performance Marketers', 'Brand Managers', 'Social Media Managers'],
    avoidFor: ['Investment Bankers', 'Software Engineers', 'Traditional Lawyers'],
    dna: ['Visual-Modern', 'Teal-Accents', 'Two-Column-Magazine', 'Creativity-Driven', 'Sans-Serif'],
    metrics: {
      readingDifficulty: 90,
      scanningSpeed: 91,
      visualAppeal: 96
    },
    hiringManager: {
      firstImpression: "Vibrant, creative marketing professional with analytical campaign execution skills",
      scanningStyle: "Two-column visual scan focusing on campaign reach, brand growth, and tools proficiencies",
      preferredStructure: "Summary and experience in main body; education, skills, and languages in sidebar",
      dislikes: ["Dry black-and-white layouts", "No mention of metrics (CTR, CPA, ROI)", "No LinkedIn/portfolio links"]
    },
    strategy: {
      goal: "Hook creative agency and consumer brand recruiters with a modern visual design",
      focus: "Campaign metrics (conversions, reach), content strategy tools, and branding experience",
      avoid: ["Traditional serif layouts", "Dense block text formatting"]
    },
    psychology: {
      coreTraits: ["Creativity", "Energy", "Analytical campaign execution", "Modernity"]
    },
    readingPattern: {
      fPattern: true,
      zPattern: false,
      linear: false,
      sidebar: true
    },
    aiPrompt: {
      writingStyle: "Highlight marketing metrics (e.g. 'improved CTR by 24%', 'managed $50K budget with 4x ROI'). Use modern active branding terms.",
      rewriteStyle: "Creative, persuasive, campaign-focused"
    },
    accessibility: {
      contrast: "AAA",
      fontSizeMin: "9.5pt",
      lineHeight: 1.45,
      screenReaderHeading: true
    },
    print: {
      a4: true,
      letter: true,
      inkSaving: true,
      cmykSafe: true
    },
    export: {
      pdf: true,
      docx: true,
      latex: false,
      html: true
    }
  },
  layouts: {
    'two-column': {
      component: 'two-column',
      slots: {
        header: ['personal-info'],
        sidebar: ['skills', 'languages', 'education'],
        main: ['summary', 'experience', 'projects']
      },
      overrides: {
        '--layout-sidebar-width': '197px',
        '--layout-column-gap': '20px'
      }
    }
  },
  styleOverrides: {
    '--font-size-display': '26pt',
    '--weight-display': '800',
    '--heading-text-transform': 'none',
    '--heading-weight': '600',
    '--border-thickness-heading': '2.5px',
    '--bullet-style': 'square',
    '--spacing-section-mb': '18px',
    '--spacing-item-mb': '12px',
    '--spacing-bullet-gap': '5px',
    '--color-text-main': '#2C3E50',
    '--color-text-light': '#7F8C8D'
  }
};
export default marketingSpecialist;
